<div class="new-contract-container">
<form [formGroup]="constractForm"  class="mb-2">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Firma</mat-label>
    <mat-select formControlName="company" name="company">
      @for (company of companies; track company) {
        <mat-option [value]="company.value">{{company.name}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Vorschlag</mat-label>
    <input type="text"
           placeholder="Pick one"
           aria-label="Vorschlag"
           matInput
           formControlName="template"
           [matAutocomplete]="auto" (input)="searchTemplates($event)">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayTemplate">
      @for (option of templates()?.content; track option) {
        <mat-option [value]="option">{{option.name}}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Apotheke</mat-label>
    <input type="text"
           placeholder="Pick one"
           aria-label="Apotheke"
           matInput
           formControlName="idf"
           [matAutocomplete]="auto1" (input)="searchAccounts($event)">
    <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayAccount">
      @for (account of idfs()?.content; track account) {
        <mat-option [value]="account">{{account.idf}} - {{account.name}}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field appearance="outline" >
    <mat-label>Valid From</mat-label>
    <input matInput [matDatepicker]="start" formControlName="validFrom">
    <mat-hint>MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="start"></mat-datepicker-toggle>
    <mat-datepicker #start></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" >
    <mat-label>Valid Until</mat-label>
    <input matInput [matDatepicker]="end" formControlName="validUntil">
    <mat-hint>MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="end"></mat-datepicker-toggle>
    <mat-datepicker #end></mat-datepicker>
  </mat-form-field>

  <button mat-raised-button (click)="addToCart()">Zum Ablagekorb</button>
  <button mat-raised-button (click)="prepareContract()" [disabled]="preparingContract() || exportingPdf()">Prepare Contract</button>
  <button mat-raised-button (click)="saveContract()" [disabled]="preparingContract() || exportingPdf() || preparedContractPages.length === 0">Save Contract</button>
</form>
  <div class="prepared-contract" id="contractView">
    @for (page of preparedContractPages; track page){
      <mat-card class="mb-5">
        <mat-card-content>
          <div [innerHtml]="page.header_html"></div>
          <div [innerHtml]="page.body_html"></div>
          <div [innerHtml]="page.footer_html"></div>
        </mat-card-content>
      </mat-card>
    }
  </div>
</div>
